export default {"src":"/_next/static/media/DeleteIconTjRed.14bde529.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};